export class Family {
    id: number;
    name: string;
    parent: Family;
    deleted: boolean;
    code: string;
    errorCode: {
        message: string,
        code: string,
    };
}
